module.exports = __webpack_public_path__ + "img/blue-gross-icon.48c1535c.svg";